(function () {
  if (!window.fetch) return;

  function disableCheckoutIfZero() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const isZero = cart.total_price === 0;

        // MAIN CART CHECKOUT BUTTON
        document
          .querySelectorAll('button[name="checkout"], .cart__checkout, .cart__submit')
          .forEach(btn => {
            btn.disabled = isZero;
            btn.style.pointerEvents = isZero ? 'none' : 'auto';
            btn.style.opacity = isZero ? '0.5' : '1';
            btn.title = isZero ? 'Add items to cart before checkout' : '';
          });

        // SIDE CART CHECKOUT BUTTON (QSC)
        document
          .querySelectorAll('.qsc2-checkout-button')
          .forEach(btn => {
            btn.disabled = isZero;
            btn.style.pointerEvents = isZero ? 'none' : 'auto';
            btn.style.opacity = isZero ? '0.5' : '1';
            btn.title = isZero ? 'Add items to cart before checkout' : '';
          });
      });
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', disableCheckoutIfZero);

  // Side cart updates
  document.addEventListener('booster:content:update', disableCheckoutIfZero);

  // Retry for async carts
  setTimeout(disableCheckoutIfZero, 300);
  setTimeout(disableCheckoutIfZero, 800);
  setTimeout(disableCheckoutIfZero, 1500);

  function removeMetallicIncludedItemsIfNoKit() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      let hasMetallicKit = false;
      const updates = {};

      cart.items.forEach(item => {
        const title = (item.product_title || '').toLowerCase();

        // ✅ Detect PAID Metallic Kit
        if (
          title.includes('metallic epoxy flooring system') &&
          item.final_price > 0
        ) {
          hasMetallicKit = true;
        }
      });

      // ❌ If no kit, remove all "Included" metallic items
      if (!hasMetallicKit) {
        cart.items.forEach(item => {
          if (
            item.properties &&
            item.properties['Bundle Block'] &&   // <-- KEY
            item.final_price === 0
          ) {
            updates[item.key] = 0;
          }
        });
      }

      if (Object.keys(updates).length) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      }
    });
}
document.addEventListener('DOMContentLoaded', removeMetallicIncludedItemsIfNoKit);
document.addEventListener('booster:content:update', removeMetallicIncludedItemsIfNoKit);

setTimeout(removeMetallicIncludedItemsIfNoKit, 300);
setTimeout(removeMetallicIncludedItemsIfNoKit, 800);
setTimeout(removeMetallicIncludedItemsIfNoKit, 1500);



})();
